import { createDecorator } from 'vue-class-component'
import Vue from 'vue';




export function SyncValue<T>(
  queryKey: string,
  { validate = e => true, defaultValue = "" as any as T, map = e => e, revMap = e => e }: {
    validate?: (e: T) => boolean,
    map?: (e: any) => T,
    revMap?: (e: T) => any,
    defaultValue?: T
  } = {}
) {
  return createDecorator((options, key) => {
    if (!options.computed)
      options.computed = {}

    options.computed[key] = {
      get() {
        try {
          var temp = map((<any>this)[queryKey] || '')
          return validate(temp as T) ? (temp || defaultValue) : defaultValue
        } catch (error) {
          return defaultValue
        }
      },
      set(value: T) {
        this[queryKey] = revMap(value)
      }
    }
  })
}

let localStorageData = {}

try {
  console.time("localstorage")
  localStorageData = JSON.parse(localStorage.getItem("vue-localstorage")) || {}
  console.timeEnd("localstorage")
} catch (error) {}

try {
  localStorageData = Vue.observable(localStorageData)
} catch (error) {}

export function SyncWithLocalStorage<T>(
  queryKey?: string | ((e: any) => string),
  { validate = e => true, defaultValue = "" as any as T, map = e => e, revMap = e => e }: {
    validate?: (e: T) => boolean,
    map?: (e: any) => T,
    revMap?: (e: T) => any,
    defaultValue?: T
  } = {}
) {
  return createDecorator((options, key) => {
    if (!options.computed)
      options.computed = {}
    if(!queryKey){
      queryKey = options.name + '_' + key
      if(localStorageData[queryKey] === undefined)
        Vue.set(localStorageData,queryKey,defaultValue)
    }
    options.computed[key] = {
      get() {
        try {
          if (typeof queryKey == "function")
            queryKey = queryKey(this)
          var temp = map(localStorageData[queryKey] || '')
          return validate(temp as T) ? (temp || defaultValue) : defaultValue
        } catch {
          return defaultValue
        }
      },
      set(value: T) {
        console.log(value)
        try {
          if (typeof queryKey == "function")
            queryKey = queryKey(this)
          Vue.set(localStorageData,queryKey,revMap(value))
          localStorage.setItem("vue-localstorage",JSON.stringify(localStorageData))
        } catch {}
      }
    }
  })
}


export function SyncBooleanWithLocalStorage(
  queryKey?: string | ((e: any) => string),
) {
  return SyncWithLocalStorage<boolean>(
    queryKey,
    {
      defaultValue: false,
      map: e => e == 'true',
      revMap: e => e ? 'true' : 'false',
    }
  )
}
